import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface KeyPlatformFeature {
  id: string;
  /** Full mandate / function statement */
  statement: string;
}

@Component({
  selector: 'app-key-platform-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './key-platform-features.component.html',
  styleUrl: './key-platform-features.component.scss',
})
export class KeyPlatformFeaturesComponent {
  readonly sectionTitle = 'National Digital Health Mission — key functions';

  features: KeyPlatformFeature[] = [
    {
      id: 'ndhm-leadership',
      statement:
        'Administrative and technical leadership to the National Digital Health Mission',
    },
    {
      id: 'policy-directions',
      statement:
        'Propose policy directions as required to the Mission Steering Group, Empowered Committee and MoHFW',
    },
    {
      id: 'policy-implementation',
      statement:
        'Implementation of policies and decisions approved by the Mission Steering Group and Empowered Committee',
    },
    {
      id: 'self-financing',
      statement:
        'Development of models for self-financing of National Digital Health Mission',
    },
    {
      id: 'abdm-operations',
      statement: 'Management of day-to-day operations of ABDM',
    },
    {
      id: 'issue-resolution',
      statement: 'Resolution of technical and operation issues',
    },
    {
      id: 'coordination',
      statement: 'Coordination with MoHFW and the States/UTs',
    },
    {
      id: 'stakeholders',
      statement:
        'Engagement with all stakeholders including private sector and civil society organizations, and develop strategic partnerships to achieve the objectives of ABDM',
    },
    {
      id: 'capacity',
      statement:
        'Capacity building of various stakeholders for health informatics',
    },
    {
      id: 'recruitment',
      statement:
        'Recruitment of resources from Government and private sector at competitive market rates',
    },
  ];
}
